import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { debounceTime } from 'rxjs';
import { InnovationRequestService } from '../innovation-request.service';
import { InnovationRequestsFilterService } from '../innovation-requests-filter.service';

@Component({
    selector: 'app-innovation-requests-active-filters',
    templateUrl: './innovation-requests-active-filters.component.html',
    standalone: true,
    imports: [NgFor, NgSwitch, NgIf, NgSwitchCase, DatePipe, TranslateModule]
})
export class InnovationRequestsActiveFiltersComponent {

    formKeys: string[];
    formControls: Record<string, AbstractControl<any, any>>;
    queryId = '';
    personId = '';
    firstName = '';
    phoneNumber = '';
	@Input() table: Table;

	constructor(
		public readonly innovationRequestsFilterService: InnovationRequestsFilterService,
		public readonly innovationRequestService: InnovationRequestService
	) {
	    this.initializeFormControls();

	    this.innovationRequestsFilterService.filterHandler()
	        .pipe(debounceTime(300))
	        .subscribe(() => {
	            this.innovationRequestsFilterService.searchingByColumnFilter = true;
	            this.initializeFormControls();
	        });
	}

	initializeFormControls(): void {
	    this.formControls = this.innovationRequestsFilterService.form.controls;
	    this.formKeys = [];

	    for (const key in this.formControls) {
	        if (Object.prototype.hasOwnProperty.call(this.formControls, key)) {
	            this.formKeys.push(key);
	        }
	    }

	    this.queryId = this.innovationRequestsFilterService.form.controls['queryId'].value;
	    this.personId = this.innovationRequestsFilterService.form.controls['personId'].value;
	    this.firstName = this.innovationRequestsFilterService.form.controls['firstName'].value;
	    this.phoneNumber = this.innovationRequestsFilterService.form.controls['phoneNumber'].value;
	}

	getFormControlObject(key: string): AbstractControl<any, any> {
	    return this.formControls[key];
	}

	isFilterActive(key: string): boolean {
	    const value = this.formControls[key].value;
	    return value != null && value !== '';
	}

	thereIsMoreThanOneFilterActive(): boolean {
	    return this.formKeys.filter(key => this.isFilterActive(key)).length >= 2;
	}

	clearFilter(key: string): void {
	    if (this[`${key}`]) this[`${key}`] = ''; // this.queryId = ''; this.personId = ''; this.firstName = ''; this.email = ''; this.phoneNumber = '';
	    this.innovationRequestsFilterService.clearFilter(key);
	}

	clearAllFiltersAndGlobalSearch(): void {
	    this.queryId = '';
	    this.personId = '';
	    this.firstName = '';
	    this.phoneNumber = '';
	    this.innovationRequestsFilterService.clearAllFiltersAndGlobalSearch();

	    // reset sort field of the table
	    this.innovationRequestsFilterService.resetSortField();
	    if (this.table) { this.table.reset(); }
	}
}
